import React, { memo } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalOverlay,
  ModalContent,
  InputGroup,
  InputRightElement,
  useDisclosure,
} from "@chakra-ui/react";
import TableOpenContract from "./tableOpenContract";
import toast from "react-hot-toast";
import { useState, useEffect } from "react";
import { useContract } from "../../hooks/useContract";
import { exportFile } from "../../utils/tools";
import iconExport from "../../assets/images/product/iconExport.svg";
import { contractCall } from "../../api/contract";
import iconFile from "../../assets/images/apartment/Frame.svg";
import IconFile from "../../assets/images/booking/upfile.svg";
import PopupImport from "../../components/popup/PopupImport";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import IconX from "../../assets/images/booking/x-circle.svg";

const columnMappingImportAgentReverse = {
  "Tên dự án": "projectName",
  "Mã căn hộ": "apartmentCode",
  "Ngày đóng HĐMB": "priceTime",
  "Số tiền đóng HĐMB": "price",
  "Phương thức thanh toán": "paymentMethodName",
  "Ghi chú": "note",

  // customer
  "Tên khách hàng hoặc công ty": "customerName",
  "Mã CCCD": "identificationNumber",
  "Mã số thuế": "businessTaxCode",
  // agent
  "Tên đại lý": "agentName",
};

export default function Contract() {
  const [paramExport, setParamExport] = useState(null);
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const { refetch, isRefetching, entries, contractData } = useContract();

  const handleExport = async () => {
    const columnMapping = {
      status: "Trạng thái",
      code: "Mã HĐMB",
      ttkq: "Mã TTKQ",
      locking: "Mã Locking",
      project: "Dự án",
      apartment: "Mã sản phẩm",
      nameApartment: "Tên sản phẩm",
      customer: "Tên khách hàng",
      time: "Ngày ký hợp đồng",
      // invoice: "Phiếu tính giá",
      paymentMethod: "Phương thức thanh toán",
      creator: "Người tạo HĐMB",
      approver: "Người chấp nhận HĐMB",
      saleBlock: "Khối",
      saleArea: "Vùng",
      createdAt: "Ngày chuyển HĐMB",
      // note: "Note",
    };
    if (contractData?.length) {
      const data = await contractCall.export(entries, paramExport);
      if (data) {
        exportFile(data, columnMapping, "bang_quan_ly_HDMB.xlsx");
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else toast.error("Không có dữ liệu");
  };

  const handleExportV2 = async () => {
    const columnMapping = {
      code: "Mã giao dịch",
      projectCode: "Mã dự án",
      apartmentCode: "Mã căn",
      customer: "Số điện thoại khách hàng",
      creatorCode: "Mã nhân viên tạo",
      saleBlock: "Khối",
      saleBlockManagerCode: "Mã giám đốc khối",
      saleArea: "Vùng",
      saleAreaManagerCode: "Mã giám đốc vùng",
      branch: "Chi nhánh", // Chi nhánh
      saleBranchManagerCode: "Mã giám đốc chi nhánh",

      statusBooking: "Trạng thái booking",
      priceBooking: "Số tiền booking",
      timeBooking: "Ngày cọc booking",
      PaymentMethodBooking: "Hình thức thanh toán booking",
      additionalInformationBooking: "Thông tin thêm booking",
      noteBooking: "Ghi chú booking",

      statusLocking: "Trạng thái locking",
      priceLocking: "Số tiền locking",
      timeLocking: "Ngày cọc locking",
      PaymentMethodLocking: "Hình thức thanh toán locking",
      additionalInformationLocking: "Thông tin thêm locking",
      noteLocking: "Ghi chú locking",

      statusTtkq: "Trạng thái ttkq",
      priceTtkq: "Số tiền ttkq",
      timeTtkq: "Ngày cọc ttkq",
      PaymentMethodTtkq: "Hình thức thanh toán ttkq",
      additionalInformationTtkq: "Thông tin thêm ttkq",
      noteTtkq: "Ghi chú ttkq",

      statusHdmb: "Trạng thái hdmb",
      priceHdmb: "Số tiền hdmb",
      timeHdmb: "Ngày cọc hdmb",
      PaymentMethodHdmb: "Hình thức thanh toán hdmb",
      additionalInformationHdmb: "Thông tin thêm hdmb",
      noteHdmb: "Ghi chú hdmb",

      inputLate: "Trạng thái nhập muộn",
      isWrongInput: "Trạng thái nhập sai",
    };
    if (contractData?.length) {
      const data = await contractCall.exportV2(entries, paramExport);
      if (data) {
        exportFile(data, columnMapping, "bang_quan_ly_giao_dich.xlsx");
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else toast.error("Không có dữ liệu");
  };

  const [popupVisible, setPopupVisible] = useState(false);
  const [popupImportAgentVisible, setPopupImportAgentVisible] = useState(false);
  const handleExportAgentSample = () => {
    const columnMapping = {
      projectName: "Tên dự án",
      apartmentCode: "Mã căn hộ",
      priceTime: "Ngày đóng HĐMB",
      price: "Số tiền đóng HĐMB",
      paymentMethodName: "Phương thức thanh toán",
      note: "Ghi chú",

      // customer
      customerName: "Tên khách hàng hoặc công ty",
      identificationNumber: "Mã CCCD",
      businessTaxCode: "Mã số thuế",
      // agent
      agentName: "Tên đại lý",
    };
    const data = [
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        priceTime: "2024-11-17",
        price: "100,000,000.1",
        paymentMethodName: "Thanh toán tiến độ/Thanh toán thông thường",
        note: "abc",

        // customer
        customerName: "Nguyễn Quốc Đạt",
        identificationNumber: "030200007777",
        // agent
        agentName: "Đại lý MSH",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        priceTime: "2024-11-17",
        price: "100,000,000.1",
        paymentMethodName: "Vay vốn ngân hàng/Hỗ trợ lãi suất",
        note: "abc",

        // customer
        customerName: "MSH Group",
        businessTaxCode: "777",
        // agent
        agentName: "Đại lý MSH",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        priceTime: "2024-11-17",
        price: "100,000,000.1",
        paymentMethodName: "Thanh toán sớm/Thanh toán nhanh",
        note: "abc",

        // customer
        customerName: "Phạm Đức Trung",
        identificationNumber: "030200001111",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        priceTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",

        // customer
        customerName: "MSH Group",
        businessTaxCode: "777",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        priceTime: "2024-11-17",
        price: "100,000,000.1",
        paymentMethodName: "Thanh toán sớm/Thanh toán nhanh",
        note: "abc",

        // agent
      },
    ];
    try {
      exportFile(data, columnMapping, "bang_hdmb.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };
  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý hợp đồng mua bán
          </Text>
        </Flex>
        <Flex alignItems={"center"} gap={"16px"}>
          <Button
            w={"176px"}
            h={"44px"}
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExport}
          >
            <Image src={iconExport} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất exel
            </Text>
          </Button>

          <Button
            w={"176px"}
            h={"44px"}
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={onOpen}
          >
            <Image src={iconExport} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất giao dịch
            </Text>
          </Button>

          <Menu>
            <MenuButton
              w={"180px"}
              h={"44px"}
              as={Button}
              p="10px 16px"
              backgroundImage="var(--color-button)"
              _hover={{
                filter: "brightness(90%)",
              }}
            >
              <Flex alignItems="center" gap="8px" w={"full"}>
                <Image src={IconFile} />
                <Text
                  fontSize="15px"
                  fontWeight={600}
                  color="var(--color-main)"
                >
                  Tải file lên
                </Text>
              </Flex>
            </MenuButton>
            <MenuList>
              {/* <MenuItem
                        onClick={() => setPopupVisible(true)}
                        gap={"16px"}
                        p={"10px 16px"}
                        _hover={{
                          filter: "brightness(96%)",
                        }}
                      >
                        <Image src={iconFile} /> Import locking
                      </MenuItem> */}
              <MenuItem
                onClick={() => setPopupImportAgentVisible(true)}
                gap={"16px"}
                p={"10px 16px"}
                _hover={{
                  filter: "brightness(96%)",
                }}
              >
                <Image src={iconFile} /> Import HĐMB đại lý
              </MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableOpenContract
          isRefetchingWithCreate={isRefetching}
          paramData={setParamExport}
        />
      </Box>
      {/* <AddOpenForSale
        isOpen={isOpen}
        onClose={onClose}
        isEdit={false}
        onSubmit={() => {
          console.log("dat");
        }}
      /> */}
      {popupImportAgentVisible && (
        <PopupImport
          isOpen={popupImportAgentVisible}
          onClose={() => setPopupImportAgentVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingImportAgentReverse}
          handleExport={handleExportAgentSample}
          titleAdd="Thêm danh sách HĐMB đại lý"
          inputAdd="Nhập danh sách HĐMB đại lý"
          type={"contractAgent"}
          isTypePrice={true}
        />
      )}
      <PopupExport
        isOpen={isOpen}
        onClose={onClose}
        entries={entries}
        contractData={contractData}
      />
    </Box>
  );
}

const PopupExport = memo(({ isOpen, onClose, entries, contractData }) => {
  const [paramExport, setParamExport] = useState(null);
  const [zIndex, setZIndex] = useState(1);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    setParamExport({
      startDate,
      endDate,
    });
  }, [startDate, endDate]);

  const handleExportV2 = async () => {
    const columnMapping = {
      code: "Mã giao dịch",
      projectCode: "Mã dự án",
      saleOpeningEventCode: "Mã đợt mở bán",
      apartmentCode: "Mã căn",
      customer: "Số điện thoại khách hàng",
      creatorCode: "Mã nhân viên tạo",
      saleBlock: "Khối",
      saleBlockManagerCode: "Mã giám đốc khối",
      saleArea: "Vùng",
      saleAreaManagerCode: "Mã giám đốc vùng",
      branch: "Chi nhánh",
      saleBranchManagerCode: "Mã giám đốc chi nhánh",

      statusBooking: "Trạng thái booking",
      priceBooking: "Số tiền booking",
      timeBooking: "Ngày cọc booking",
      PaymentMethodBooking: "Hình thức thanh toán booking",
      additionalInformationBooking: "Thông tin thêm booking",
      noteBooking: "Ghi chú booking",
      employeeCodeApproveBooking: "Nhân viên duyệt booking",
      timeApproveBooking: "Thời gian duyệt booking",

      statusLocking: "Trạng thái locking",
      priceLocking: "Số tiền locking",
      timeLocking: "Ngày cọc locking",
      PaymentMethodLocking: "Hình thức thanh toán locking",
      additionalInformationLocking: "Thông tin thêm locking",
      noteLocking: "Ghi chú locking",
      employeeCodeApproveLocking: "Nhân viên duyệt locking",
      timeApproveLocking: "Thời gian duyệt locking",

      statusTtkq: "Trạng thái ttkq",
      priceTtkq: "Số tiền ttkq",
      timeTtkq: "Ngày cọc ttkq",
      PaymentMethodTtkq: "Hình thức thanh toán ttkq",
      additionalInformationTtkq: "Thông tin thêm ttkq",
      noteTtkq: "Ghi chú ttkq",
      employeeCodeApproveTtkq: "Nhân viên duyệt ttkq",
      timeApproveTtkq: "Thời gian duyệt ttkq",

      statusHdmb: "Trạng thái hdmb",
      priceHdmb: "Số tiền hdmb",
      timeHdmb: "Ngày cọc hdmb",
      PaymentMethodHdmb: "Hình thức thanh toán hdmb",
      additionalInformationHdmb: "Thông tin thêm hdmb",
      noteHdmb: "Ghi chú hdmb",
      employeeCodeApproveHdmb: "Nhân viên duyệt hdmb",
      timeApproveHdmb: "Thời gian duyệt hdmb",

      inputLate: "Trạng thái nhập muộn",
      isWrongInput: "Trạng thái nhập sai",
    };

    try {
      if (!contractData?.length) {
        toast.error("Không có dữ liệu");
        return;
      }

      const data = await contractCall.exportV2(paramExport);

      if (!Array.isArray(data) || data.length === 0) {
        toast.error("Không có dữ liệu để xuất file");
        return;
      }

      exportFile(data, columnMapping, "bang_quan_ly_giao_dich.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      console.error("Export transaction error:", error);
      toast.error("Xuất file thất bại");
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"1024px"}
      >
        <Flex
          alignItems={"center"}
          p={"25px 24px 24px 24px"}
          position={"relative"}
          borderBottom={"1px solid var(--border-input-employee)"}
        >
          <Text
            color={"var(--color-header-employee)"}
            fontSize={"16px"}
            fontWeight={"600"}
          >
            Xuất chi tiết giao dịch
          </Text>
          <Box
            position={"absolute"}
            top={"24px"}
            right={"24px"}
            cursor={"pointer"}
            onClick={onClose}
          >
            <Image src={IconX} />
          </Box>
        </Flex>
        <Box padding={"24px"}>
          <Flex
            alignItems={"center"}
            gap={{ base: "16px 32px" }}
            flex={"1"}
            flexWrap={"wrap"}
            w={"100%"}
            paddingBottom={"32px"}
          >
            <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                dateFormat="dd/MM/yyyy"
                locale="vi"
                onChange={(update) => {
                  setDateRange(update);
                }}
                onFocus={() => {
                  setZIndex(3);
                }}
                onBlur={() => {
                  setZIndex(1);
                }}
                isClearable={true}
                placeholderText="Ngày đặt cọc từ ngày - đến ngày"
                className="datePickerStyle"
              />
              {!startDate && !endDate && (
                <InputRightElement pointerEvents="none" h={"44px"}>
                  <Image src={calendarIcon} />
                </InputRightElement>
              )}
            </InputGroup>
          </Flex>
          <Box
            // position={"absolute"}
            w={"100%"}
            // bottom={"0"}
            bg={"var(--color-main)"}
            borderTop={"0.5px solid var(--bg-line-employee)"}
            borderRadius={"0px 0px 16px 16px"}
            zIndex={3}
          >
            <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
              <Button
                w={"112px"}
                p={"13px 20px"}
                fontSize={"15px"}
                fontWeight={600}
                color={"var(--color-option-employee-hover)"}
                borderRadius={"8px"}
                border={"1px solid var(--color-option-employee-hover)"}
                bg={"var(--color-main)"}
                _hover={{
                  filter: "brightness(90%)",
                }}
                onClick={onClose}
              >
                Hủy
              </Button>
              <Button
                onClick={handleExportV2}
                w={"112px"}
                p={"13px 20px"}
                fontSize={"15px"}
                fontWeight={600}
                color={"var(--color-main)"}
                borderRadius={"8px"}
                bg={"var(--color-option-employee-hover)"}
                _hover={{
                  filter: "brightness(90%)",
                }}
              >
                Xuất excel
              </Button>
            </Flex>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
});
